<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="18rem"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">{{ title }}</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item
        label="报警渠道"
        style="width: 280px; display: inline-block"
      >
        {{ ruleForm.SourceDesc }}
      </el-form-item>
      <el-form-item label="报警时间" style="display: inline-block">
        {{ formatDate(ruleForm.BeginDate) }}
      </el-form-item>
      <el-form-item label="求助地点">
        {{ ruleForm.Location }}
      </el-form-item>
      <!-- <el-form-item label="详细地址"  >
      {{ruleForm.Location}}
    </el-form-item> -->
      <el-form-item label="求助人">
        {{ ruleForm.Contact }}
      </el-form-item>
      <el-form-item label="求助人联系电话">
        {{ ruleForm.Phone }}
      </el-form-item>
      <el-form-item label="求助内容">
        {{ ruleForm.Content }}
      </el-form-item>
      <!--待受理的时候显示-->
      <el-form-item label="处理方式" prop="ProcessWay" v-if="status == '0'">
        <el-radio-group
          v-model="ruleForm.ProcessWay"
          @change="changeProcessWay"
        >
          <el-radio label="1">转为应急事件</el-radio>
          <el-radio label="4">正常受理</el-radio>
          <el-radio label="5">不予受理（虚报）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="初判事件类型" prop="EventType" v-if="status == '0'">
        <el-radio-group v-model="ruleForm.EventType">
          <el-radio label="伤员求助"></el-radio>
          <el-radio label="暴雨求助"></el-radio>
          <el-radio label="其他"></el-radio>
        </el-radio-group>
      </el-form-item>
      <!-- 待结案的时候显示 -->
      <el-form-item label="是否受理" prop="ProcessWay" v-if="status != '0'">
        <el-radio-group v-model="ruleForm.ProcessWay" :disabled="status != '0'">
          <el-radio label="1">转为应急事件</el-radio>
          <el-radio label="4">受理</el-radio>
          <el-radio label="5">不予受理（虚报）</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="受理日期" v-if="status != '0'">
        {{ formatDate(ruleForm.AcceptDate) }}
      </el-form-item>
      <el-form-item label="确认事件类型" prop="EventType" v-if="status != '0'">
        <el-radio-group v-model="ruleForm.EventType" :disabled="status == '2'">
          <el-radio label="伤员求助"></el-radio>
          <el-radio label="暴雨求助"></el-radio>
          <el-radio label="其他"></el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="结案说明"
        prop="ProcessConclusion"
        style="width: 80rem"
        v-if="status != '0'"
      >
        <el-input
          type="textarea"
          v-model="ruleForm.ProcessConclusion"
          :disabled="status == '2'"
        ></el-input>
      </el-form-item>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-show="IsEdit == false"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
    <el-dialog
      title="应急接报"
      class="emergencyoperations-dialog event-normal"
      custom-class="bg3"
      top="6vh"
      :visible.sync="dialogVisible"
      width="75%"
      :before-close="handleClose"
      :append-to-body="true"
      style="text-align: left"
      :destroy-on-close="true"
    >
      <EventInfo
        :IsEdit="IsEdit"
        :EventConfirm="EventConfirm"
        :IsAdd="IsAdd"
        :EventReport="EventReport"
      ></EventInfo>
    </el-dialog>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import EventInfo from "../../../../../emergency/src/views/src/Event/EventInfo.vue";
import { saveBySource } from "@/request/msgApi";
export default {
  name: "WaitingForHelpInfo",
  controller: "UI",
  action: "WaitingForHelpInfo",
  components: {
    EventInfo,
  },
  data() {
    return {
      ruleForm: {
        AlertType: "", //预警类型
        AlerteLevel: null, //预警级别
        Phone: "", //求助人电话
        Location: "", //求助地点
        SourceDesc: "", //求助渠道
        ProcessStatus: "", //处理状态 0待处理 1待结案 2已结案
        BeginDate: "",
        EndDate: "",
        Content: "",
        AcceptDate: "", //受理日期
        ProcessWay: "", //是否受理 处理方式  1 - 转应急事件  4 - 正常受理 5 - 不予受理（虚报）
        ProcessConclusion: "", //结案说明
        FinishDate: "", //结案日期
        EventType: "", //初判事件类型
      },
      rules: {
        ProcessWay: [
          { required: true, message: "请选择处理方式", trigger: "change" },
        ],
        EventType: [
          { required: true, message: "请选择事件类型", trigger: "change" },
        ],
        ProcessConclusion: [
          { required: true, message: "请填写结案说明", trigger: "change" },
        ],
      },
      IsEdit: false,
      status: "",
      title: "待处理求助",
      dialogVisible: false,
      EventConfirm: false,
      EventReport: false,
      IsAdd: true,
    };
  },
  created: function () {
    this.IsEdit = this.$route.query.type == "edit" ? false : true;
    this.search();
  },
  mounted: function () {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      let Id = this.$route.query.Id;
      if (Id != null && Id != "") {
        let searchInfo = {
          Id: Id,
        };
        new MyApis.SeekHelpApi()
          .GetItemById(searchInfo)
          .then((r) => {
            r = r.data.Data;
            console.log(r);
            this.ruleForm = r;
            this.ruleForm.ProcessWay = this.ruleForm.ProcessWay + "";
            this.status = this.ruleForm.ProcessStatus;
            if (this.ruleForm.ProcessStatus == "0") {
              this.title = "待处理求助";
            } else if (this.ruleForm.ProcessStatus == "1") {
              this.title = "待结案求助";
            } else if (this.ruleForm.ProcessStatus == "2") {
              this.title = "已结案求助";
            } else {
              this.title = "待处理求助";
            }
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    changeProcessWay(val) {
      if (val === "1") {
        // this.dialogVisible = true;
        this.$confirm("确认转为应急事件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          //更改消息为已读
          this.saveBySource();
          let path = `/plugin/Emergency/UI/NewEvent?AlarmId=${this.ruleForm.Id}`;
          this.$router.push(path);
        });
      }
    },
    save() {
      let status = this.ruleForm.ProcessStatus;
      if (status == "0" || status == "") {
        //0是待处理 1是待结案
        if (this.ruleForm.ProcessWay == "1") {
          this.ruleForm.FinishDate = this.time(new Date());
          this.ruleForm.AcceptDate = this.time(new Date());
          this.ruleForm.ProcessConclusion = "已转为应急事件";
          this.ruleForm.ProcessStatus = "2";
        } else {
          this.ruleForm.AcceptDate = this.time(new Date());
          this.ruleForm.ProcessStatus = "1";
        }
      } else if (status == "1") {
        this.ruleForm.FinishDate = this.time(new Date());
        this.ruleForm.ProcessStatus = "2";
      }
      console.log(this.ruleForm);
      if (!this.ruleForm.ProcessWay || this.ruleForm.ProcessWay === "0") {
        return this.$message.error("请选择处理方式");
      }
      if (!this.ruleForm.EventType) {
        return this.$message.error("请选择初判事件类型！");
      }
      new MyApis.SeekHelpApi()
        .UpdateItem(this.ruleForm)
        .then((r) => {
          r = r.data.Data;
          //更改消息为已读
          this.saveBySource();
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          if (status == "1") {
            this.logInfo.ActionName = "求助结案";
            this.logInfo.LogMessage = "求助结案成功";
            this.logInfo.PageName = "待结案求助详情";
          } else {
            this.logInfo.ActionName = "求助处理";
            this.logInfo.LogMessage = "求助处理成功";
            this.logInfo.PageName = "待处理求助详情";
          }
          this.logInfo.ModuleName = "紧急求助";
          this.addOperationLog();
          this.$router.go(-1); //返回上一层
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    saveBySource() {
      const updateParam = {
        sourceId: this.$route.query.Id,
        isRead: 1,
      };
      saveBySource(updateParam).then((res) => {});
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    },
    time(date) {
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    //日期列表展示格式
    formatDate(value) {
      // 获取单元格数据
      let data = value;
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
};
</script>
<style scoped s>
.event_dialog .el-dialog {
  background-size: 100% 100%;
  overflow: auto;
  padding: 1.8rem 1.8rem;
  width: 70rem !important;
  height: 70rem !important;
}
.event_dialog .el-dialog__body {
  height: 100%;
  width: 100%;
}
</style>
